module.exports = __webpack_public_path__ + "img/cs.7a8db2c9.png";